export class Extract {
    constructor() {
        'ngInject';
    }

    toCsv(data, name) {

        const blob = new Blob([data], {type: 'text/csv;charset=utf-8;'});
        if ((window.navigator as any).msSaveBlob) { // IE 10+
            (window.navigator as any).msSaveBlob(blob, name);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute

                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);

                link.setAttribute('download', name);
                link.setAttribute('style',  'visibility:hidden');
                document.body.appendChild(link);  // Required for FF
                link.click(); // This will download the data file named "samples_list.csv".
                document.body.removeChild(link);
            }
        }
    }

    specialMessages(resp) {
        const isTruncated = resp.headers.get('truncatedrecords');
        if (resp.headers != null && isTruncated != null && isTruncated === 'true') {
            alert('Only 75000 rows will be extracted.');
        }
    }
}
